const RelatedModel = require('module/user/related_model')
const locationDisplayName = require('module/user/helpers/location_display_name')
const log = require('log').create('location') // eslint-disable-line

const UserLocation = RelatedModel.extend({

    defaults: {
        source: '',
        location: '',
        components: [],
    },

    calculated_values: {
        display_name() {
            return locationDisplayName(this.toJSON())
        },
    },
})

module.exports = UserLocation
